import { render, staticRenderFns } from "./Richtext.vue?vue&type=template&id=4fbb39ca"
import script from "./Richtext.vue?vue&type=script&lang=ts"
export * from "./Richtext.vue?vue&type=script&lang=ts"
import style0 from "./Richtext.vue?vue&type=style&index=0&id=4fbb39ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports